import { Component, ElementRef } from '@angular/core';
import { BARCOLOR, DiagramDatas } from '../../diagram/diagram.component';
import { ApiService } from '../../services/api/api.service';

@Component({
  selector: 'app-krankheit',
  templateUrl: './krankheit.component.html',
  styleUrls: ['./krankheit.component.css']
})
export class KrankheitComponent {

  krankheit;

  diagramDatas : DiagramDatas;

  diagramDataInits : DiagramDatas = {
    height: 300,
    diagrams: []    
  };
  
  constructor(
    private api: ApiService
  ) {
    api.getKrankheit().then((values) => {
      this.krankheit = values;      
      
      this.diagramDataInits.diagrams.push({
        bars: [
          {
            value: this.krankheit.ergVersorgungszielKrankheit.value,
            color: BARCOLOR.blue,
            left: "Versorgungsziel"     
          },
          {
            value: this.krankheit.ergVersorgungslueckeKrankheit.value,
            color: BARCOLOR.red,
            right: "Versorgungslücke",
          } 
          
        ]
      });
      
      this.diagramDatas = Object.assign({}, this.diagramDataInits);
      
    }, (error) => {
      alert( error );
    });
  }
  
  

  
  
}


// WEBPACK FOOTER //
// ./src/app/auswertung/krankheit/krankheit.component.ts